const contractAddress = '0x2a774b2eb7754a86f96478470ad389daad2e1178'
const ABI = [{'constant': false, 'inputs': [], 'name': 'incrementCounter', 'outputs': [], 'payable': false, 'stateMutability': 'nonpayable', 'type': 'function'}, {'constant': true, 'inputs': [], 'name': 'getCount', 'outputs': [{'name': '', 'type': 'int256'}], 'payable': false, 'stateMutability': 'view', 'type': 'function'}, {'constant': false, 'inputs': [], 'name': 'decrementCounter', 'outputs': [], 'payable': false, 'stateMutability': 'nonpayable', 'type': 'function'}, {'anonymous': false, 'inputs': [{'indexed': false, 'name': '_status', 'type': 'bool'}], 'name': 'incrCounterEvent', 'type': 'event'}]

export { contractAddress, ABI }



// WEBPACK FOOTER //
// ./src/util/constants/counterContract.js